<template>
<div>
    <vx-card class="mt-8">
        <div class="card-title justify-between">
            <h2 class="w-auto">Select a Location</h2>
            <!--  <img :src="dataURL"> -->
        </div>
        <div class="review-location">
            <div class="vx-row">
                <div class="vx-col xl:w-1/3 lg:w-1/2 w-full select-location">
                    <!--   <v-select v-model="location"  :options="locationoptions" /> -->
                    <v-select v-model="location" :reduce="locations => locations.LocationId" :label="'LocationName'" :options="locationoptions" :clearable="false" @input="getLandingdata()" />
                    <vs-button type="filled" icon-pack="feather" icon="icon-refresh-cw" class="refresh-btn" color="primary" @click="getLocationList()"></vs-button>
                </div>
            </div>
        </div>
    </vx-card>
    <div class="review-get-start mt-8" v-if="!createLanding">
        <div class="vx-row">
            <div class="vx-col w-full xl:w-1/4 lg:w-1/2 mb-8 lg-cus-6" v-for="(page, index) in landingpageData" :key="index">
                <vx-card class="review-card h-full">
                    <h2>{{ page.LandingPageName }}</h2>
                    <div class="review-action">
                        <vs-button radius type="filled" icon-pack="feather" icon="icon-edit" class="bg-actionbutton" @click="editLandingPage(page.LandingPageId)"></vs-button>
                        <vs-button radius color="danger" type="filled" icon-pack="feather" icon="icon-trash-2" @click="deleteLandingPage(page)"></vs-button>
                    </div>
                    <a :href="page.LandingPageUrl" target="_blank" class="mt-6 float-left w-full break-all">{{ page.LandingPageUrl }}</a>
                    <ul class="address">
                        <li v-for="(source, index) in page.LandingPageSources" :key="index">{{ source }}</li>
                    </ul>
                </vx-card>
            </div>
            <div class="vx-col w-full xl:w-1/4 lg:w-1/2 mb-8 lg-cus-6">
                <vx-card class="review-card h-full null-card">
                    <a href="#">
                        <img src="../../assets/images/landing-page.png" />
                        <vs-button radius type="filled" class="mt-4 small-btn" color="primary" @click="addLanding()">{{ LabelConstant.buttonLabelAddLandingPage }}</vs-button>
                    </a>
                </vx-card>
            </div>
        </div>
    </div>
    <vx-card v-if="createLanding" class="mt-8">
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="card-title justify-between">
                    <h2 class="w-auto">
                        {{
              !pageName
              ? "Create New Landing page"
              : "Edit Landing Page - " + pageName
              }}
                    </h2>
                </div>
            </div>
            <div class="vx-col lg:w-2/5 w-full">
                <form @submit.prevent="checkValidation()">
                    <div class="create-landing">
                        <div class="landing-section">
                            <h3>Page Info</h3>
                            <vs-input class="w-full" label="Page Name" v-model="pageName" name="pageName" v-validate="'required'" />
                            <span class="text-danger text-sm"> {{ errors.first("pageName") }} </span>
                        </div>
                        <div class="landing-section">
                            <h3>Select Header Image</h3>
                            <vs-button color="secondary" type="border" @click="selectImage = true" class="small-btn">{{ LabelConstant.buttonLabelSelectMedia }}</vs-button>
                            <img class="mt-4" v-if="contactImage" :src="'data:image/png;base64, ' + contactImage" style="height:auto; width:auto; max-width:250px; max-height:250px;" />
                        </div>
                        <div class="landing-section">
                            <h3>Message</h3>
                            <quill-editor v-model="content" ref="myQuillEditor" name="content" v-validate="'required'"></quill-editor>
                            <span class="text-danger text-sm"> {{ errors.first("content") }} </span>
                        </div>
                        <div class="landing-section">
                            <h3>Select Landing Page Type</h3>
                            <ul class="select-type">
                                <li>
                                    <vs-radio v-model="landingtype" vs-name="landingtype" :vs-value="true">First Party</vs-radio>
                                </li>
                                <li class="ml-0 sm:ml-6">
                                    <vs-radio v-model="landingtype" :vs-value="false" :disabled="thirdpartyDisable" vs-name="landingtype">Third Party</vs-radio>
                                </li>
                            </ul>
                        </div>
                        <div class="landing-section" v-if="!landingtype">
                            <h3>Select Source</h3>
                            <ul class="select-source">
                                <li v-for="(src, index) in thirdpartySource" :key="index">
                                    <vs-checkbox :vs-value="src.ListingSourceId" v-model="source" class="ml-0" v-validate="'required'" name="source">{{ src.ListingSource }}</vs-checkbox>
                                </li>
                            </ul>
                            <span class="text-danger text-sm"> {{ errors.first("source") }} </span>
                        </div>
                        <div class="flex w-full justify-end float-left mt-6">
                            <vs-button color="primary" type="filled" button="submit">{{ LabelConstant.buttonLabelSave }}</vs-button>
                            <vs-button color="grey" type="border" class="ml-4 grey-btn" @click="createEditCancel()">{{ LabelConstant.buttonLabelCancel }}</vs-button>
                        </div>
                    </div>
                </form>
            </div>
            <div class="vx-col lg:w-3/5 w-full pl-4 lg:pl-10 lg:mt-0 mt-8">
                <div class="landing-preview">
                    <h4>Help Us. Help Others. You're Invited to review:</h4>
                    <span class="my-logo">
                        <img v-if="contactImage" :src="'data:image/png;base64, ' + contactImage" />
                    </span>
                    <div v-html="content"></div>
                    <div v-if="landingtype">
                        <div class="review-landing mt-8">
                            <h3>Write a Review</h3>
                            <h5>How did we do?*</h5>
                            <star-rating :star-size="20"></star-rating>
                            <vs-input label="Name*" placeholder="Full Name" class="w-full mt-4" />
                            <vs-input label="Email*" placeholder="Email" class="w-full mt-4" />
                            <vs-input label="Review Title" placeholder="Title" class="w-full mt-4 mb-4" />
                            <div class="mt-4">
                                <label for class="w-full vs-input--label">Comments</label>
                                <vs-textarea placeholder="Describe your experience with us." class="w-full" />
                            </div>
                            <vs-button color="secondary" type="filled" class="mt-2 small-btn float-right">{{ LabelConstant.buttonLabelSubmit }}</vs-button>
                        </div>
                    </div>
                    <div v-else>
                        <ul class="landing-btn">
                            <li v-for="(source, index) in sourceList" :key="index">
                                <span class="source-btn">
                                    <img :src="source.ListingSourceImageUrl" />
                                    <b>{{ source.ListingSource }}</b>
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </vx-card>
    <!-- Select Media -->
    <vs-popup class="tag-info" title="Select an Image" :active.sync="selectImage">
        <div class="vx-row">
            <div class="vx-col input-text w-full mb-10">
                <h2 class="review-popup-title">Add New File</h2>
                <div class="upload-img flex flex-wrap">
                    <div class="upload-input">
                        <feather-icon icon="UploadCloudIcon" class="primary-c"></feather-icon>
                        <span class="file-text">Upload File</span>
                        <input type="file" ref="file" @change="addMedia($event)" />
                    </div>
                </div>
            </div>
            <div class="vx-col input-text w-full">
                <h2 class="review-popup-title mb-8">Select Existing Image</h2>
                <div class="existing-img">
                    <div class="vx-row">
                        <div class="vx-col lg:w-1/3 mb-8" v-for="(image, index) in existingImages" :key="index">
                            <div class="img-info">
                                <img :src="'data:image/png;base64, ' + image.FileContents" />
                            </div>
                            <div class="img-actions">
                                <vs-button radius color="success" type="filled" icon-pack="feather" icon="icon-check-circle" @click="selectImageFromList(image.FileContents)" class="float-left"></vs-button>
                                <vs-button radius color="danger" type="filled" icon-pack="feather" icon="icon-trash-2" class="float-left ml-2" @click="deleteMedia(image.MediaId)"></vs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="float-right mt-6 mb-8">
            <vs-button color="grey" @click="selectImage = false" type="border" class="ml-4 grey-btn">{{ LabelConstant.buttonLabelClose }}</vs-button>
        </div>
    </vs-popup>
    <!-- Delete Popup -->
    <vs-popup class="delete-popup" :active.sync="deletepopupActive">
        <template>
            <div class="vx-row mb-3">
                <div class="vx-col w-full">
                    <div class="popup-icon">
                        <feather-icon icon="Trash2Icon"></feather-icon>
                    </div>
                    <h4>Delete Landing Page ?</h4>
                    <span class="deleted-no">
                        {{
              this.pageData ? this.pageData.LandingPageName : ""
              }}
                    </span>
                </div>
            </div>
        </template>
        <div class="float-right mt-6 mb-8">
            <vs-button color="danger" type="filled" @click="deletePage()">{{ LabelConstant.buttonLabelDelete }}</vs-button>
            <vs-button @click="deletepopupActive = false" color="grey" type="border" class="ml-4 grey-btn">{{ LabelConstant.buttonLabelCancel }}</vs-button>
        </div>
    </vs-popup>
</div>
</template>

<script>
import VxCard from "@/components/vx-card/VxCard";
import vSelect from "vue-select";
import Vue from "vue";
import VueQuillEditor from "vue-quill-editor";
import StarRating from "vue-star-rating";

// require styles
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import {
    Validator
} from "vee-validate";
Vue.use(VueQuillEditor /* { default global options } */ );
const dict = {
    custom: {
        pageName: {
            required: "The page name field is required",
        },
        content: {
            required: "The message field is required",
        },
        source: {
            required: "The source field is required",
        },
    },
};
Validator.localize("en", dict);
export default {
    components: {
        VxCard,
        vSelect,
        StarRating,
    },
    created() {
        this.getLocationList();
    },
    watch: {
        source(val) {
            this.sourceList = [];
            val.forEach((element) => {
                let index = this.sources.findIndex(
                    (item) => item.ListingSourceId === element
                );
                if (index >= 0) {
                    this.sourceList.push(this.sources[index]);
                }
            });
        },
        landingtype(val) {
            if (val) {
                this.source = [];
            }
        },
    },
    data() {
        return {
            dataURL: require("@/assets/img/thirdparty/YellowBook_icon.png"),
            deletepopupActive: false,
            createLanding: false,
            selectImage: false,
            pageName: null,
            landingtype: false,
            landingPageId: null,
            pageData: null,
            content: "Please take a moment to review your experience with us. Your feedback not only helps us, it helps other potential customers. And this is another message...",
            source: [],
            location: null,
            locationoptions: [],
            sourceList: [],
            thirdpartySource: [],
            landingpageData: [],
            existingImages: [],
            sources: [],
            thirdpartyDisable: false,
            locationName: "",
            contactImage: "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",
            defaultImage: "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",
        };
    },
    methods: {
        //check validation
        checkValidation() {
            this.$validator.validateAll().then(async (result) => {
                if (result) {
                    this.createLandingPage();
                }
            });
        },
        // add media for selecting media
        async addMedia(e) {
            var reader = new FileReader();
            reader.readAsDataURL(e.target.files[0]);
            let b64;
            setTimeout(() => {
                b64 = reader.result;

                b64 = b64.split("base64,");

                b64 = b64[1];
                this.$vs.loading();
                let media = {
                    LocationId: this.location,
                    FileContents: b64,
                };
                this.axios
                    .post("/ws/ReviewGather/AddMedia", media)
                    .then(() => {
                        this.getMediaList();
                        this.$vs.loading.close();
                    })
                    .catch((e) => {
                        this.$vs.loading.close();
                        this.showError(e);
                    });
            }, 200);
        },
        // delete media
        async deleteMedia(id) {
            this.$vs.loading();
            await this.axios
                .get("/ws/ReviewGather/DeleteMedia", {
                    params: {
                        id: id,
                    },
                })
                .then(() => {
                    this.getMediaList();
                    this.$vs.loading.close();
                })
                .catch((e) => {
                    this.$vs.loading.close();
                    this.showError(e);
                });
        },
        // get location list
        async getLocationList() {
            this.$vs.loading();
            await this.axios
                .get("/ws/ReviewsGetStarted/GetLocationList")
                .then((response) => {
                    let data = response.data;
                    if (data.length <= 0) {
                        this.$router.push(
                            "/reputation-management/getting-started/uid/" +
                            this.$route.params.id +
                            "?setLocation=true"
                        );
                    }
                    this.locationoptions = data;
                    this.location = data[0].LocationId;
                    this.locationName = data[0].LocationName;
                    setTimeout(() => {
                        this.getLandingdata();
                        this.getMediaList();
                        this.getLocationSource();
                    }, 200);
                    this.$vs.loading.close();
                })
                .catch((e) => {
                    this.$vs.loading.close();
                    this.showError(e);
                });
        },
        // get landing page data
        async getLandingdata() {
            this.$vs.loading();
            await this.axios
                .get("/ws/ReviewLandingPageConfiguration/ListLandingPages", {
                    params: {
                        id: this.location,
                    },
                })
                .then((response) => {
                    let data = response.data;
                    this.landingpageData = data;

                    this.createLanding = false;
                    this.source = [];
                    this.pageData = null;
                    this.landingPageId = null;
                    this.getLocationSource();
                    this.$vs.loading.close();
                })
                .catch((e) => {
                    this.$vs.loading.close();
                    this.showError(e);
                });
        },
        // click on add landing page button
        async addLanding() {
            this.createLanding = true;
            this.getLocationSource();
        },
        // load source related to location
        async getLocationSource() {
            this.$vs.loading();
            await this.axios
                .get("ws/ReviewLandingPageConfiguration/GetSourceList", {
                    params: {
                        id: this.location,
                    },
                })
                .then((response) => {
                    let data = response.data;

                    this.sources = data;

                    const finalSource = [];
                    this.sources.forEach((source) => {
                        if (source.IsSelected) {
                            finalSource.push(source);
                        }
                    });
                    this.thirdpartySource = finalSource;
                    if (this.thirdpartySource.length == 0) {
                        this.landingtype = true;
                        this.thirdpartyDisable = true;
                    } else {
                        this.landingtype = false;
                        this.thirdpartyDisable = false;
                    }
                    this.$vs.loading.close();
                })
                .catch((e) => {
                    this.$vs.loading.close();
                    this.showError(e);
                });
        },
        //get list of media
        async getMediaList() {
            await this.axios
                .post("/ws/ReviewGather/ListMedia", {
                    LocationId: this.location,
                })
                .then((response) => {
                    let data = response.data;
                    this.existingImages = data;
                    this.$vs.loading.close();
                })
                .catch((e) => {
                    this.$vs.loading.close();
                    this.showError(e);
                });
        },
        // select image from the list
        selectImageFromList(file) {
            this.selectImage = false;
            this.contactImage = file;
        },
        // edit landing page
        async editLandingPage(id) {
            await this.axios
                .get("/ws/ReviewLandingPageConfiguration/GetLandingPageDetail", {
                    params: {
                        id: id,
                    },
                })
                .then((response) => {
                    let data = response.data;
                    this.pageName = data.LandingPageName;
                    this.landingPageId = data.LandingPageId;
                    this.landingtype = data.IsFirstParty;
                    this.contactImage = data.HeaderImage;
                    this.content = data.BodyMsg;
                    if (!data.IsFirstParty) {
                        this.source = data.SelectedSources;
                    }
                    this.createLanding = true;
                    this.$vs.loading.close();
                })
                .catch((e) => {
                    this.$vs.loading.close();
                    this.showError(e);
                });
        },
        // when we click on cancel button
        createEditCancel() {
            this.createLanding = false;
            this.landingPageId = null;
            this.pageName = null;
            this.landingtype = false;
            this.contactImage = this.defaultImage;
            this.source = [];
        },
        // create landing page api
        async createLandingPage() {
            this.$vs.loading();
            let landingPageData = {
                LocationId: this.location,
                LandingPageName: this.pageName,
                LandingPageId: !this.landingPageId ? 0 : this.landingPageId,
                HeaderImage: this.contactImage,
                BodyMsg: this.content,
                IsFirstParty: this.landingtype,
                SelectedSources: this.source,
            };
            let url = !this.landingPageId ?
                "/ws/ReviewLandingPageConfiguration/CreateLandingPage" :
                "/ws/ReviewLandingPageConfiguration/UpdateLandingPage";

            let msg = !this.landingPageId ?
                "Landing page has been created successfully." :
                "Landing page has been updated successfully.";
            await this.axios
                .post(url, landingPageData)
                .then(() => {
                    this.createLanding = false;
                    this.landingPageId = null;
                    this.contactImage = this.defaultImage;

                    this.getLandingdata();
                    this.$vs.loading.close();
                    this.$vs.notify({
                        title: "Success",
                        text: msg,
                        color: "success",
                        iconPack: "feather",
                        icon: "icon-check",
                        position: "top-right",
                        time: 4000,
                    });
                })
                .catch((e) => {
                    this.$vs.loading.close();
                    this.showError(e);
                    this.$vs.notify({
                        title: "Error",
                        text: e.response.data.Errors[0].Message,
                        color: "danger",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        position: "top-right",
                        time: 4000,
                    });
                });
        },
        // delete landing page
        deleteLandingPage(page) {
            this.pageData = page;
            this.deletepopupActive = true;
        },
        async deletePage() {
            this.$vs.loading();
            await this.axios
                .get("/ws/ReviewLandingPageConfiguration/DeleteLandingPage", {
                    params: {
                        id: this.pageData.LandingPageId,
                    },
                })
                .then((res) => {
                    this.deletepopupActive = false;
                    this.pageData = null;
                    this.landingPageId = null;
                    this.getLandingdata();
                    this.$vs.loading.close();
                    if (res.data == false) {
                        this.$vs.notify({
                            title: "",
                            text: "This landing page cannot be deleted.  It is referenced by an active review campaign",
                            color: "warning",
                            iconPack: "feather",
                            icon: "icon-alert-circle",
                            position: "top-right",
                            time: 5000,
                        });
                    }
                })
                .catch((e) => {
                    this.$vs.loading.close();
                    this.showError(e);
                });
        },
    },
};
</script>
